<template>
  <v-container>
    <loading
      :active="loader"
      :is-full-page="fullPage"
      :opacity="0.7"
      color="#ff6b00"
      :height="height"
      :width="width"
    />
    <v-row>
      <v-col
        cols="12"
        v-if="isTrans == 'true'"
        class="d-flex w-100 justify-content-end"
      >
        <v-btn color="primary" @click="onClickCancel">
          {{ $t("cancel_beneficary") }}
        </v-btn>
      </v-col>
      <v-col cols="12" md="6">
        <label>{{ $t("bankName") }}<span style="color: #f00">*</span></label>
        <v-autocomplete
          :placeholder="$t('bankName')"
          v-model="beneficiaryReqBody.bank_name"
          :items="bank_names"
          item-text="txt"
          item-value="val"
          :error-messages="bankNameErrors"
          @input="$v.beneficiaryReqBody.bank_name.$touch()"
          required
          outlined
          dense
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6">
        <label>
          {{ $t("swift_code_branch") }}</label
        >
        <v-text-field
          :placeholder="$t('swift_code_placeholder')"
          v-model="beneficiaryReqBody.swift_no"
          outlined
          dense
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <label> {{ $t("branch_code_beneficary") }}</label>
        <v-text-field
          :placeholder="$t('branch_code_beneficary')"
          v-model="beneficiaryReqBody.branch_code"
          outlined
          dense
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6" class="m-0">
        <label
          >{{ $t("account_number_beneficary")
          }}<span style="color: #f00">*</span></label
        >
        <v-text-field
          :placeholder="$t('account_number_beneficary')"
          v-model="beneficiaryReqBody.bank_account_no"
          :error-messages="accountNoErrors"
          @input="$v.beneficiaryReqBody.bank_account_no.$touch()"
          required
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="12">
        <v-btn
          class="float-left mt-5 px-5 btn-primary-outlined text-capitalize"
          @click="onClickBack"
          outlined
          ><v-icon dark left>mdi-arrow-left</v-icon> {{ $t("backLabel") }}
        </v-btn>
        <v-btn
          class="float-right mt-5 px-5 btn-primary-outlined text-capitalize"
          @click="onClickNext"
          outlined
          >{{ $t("next") }} <v-icon dark right>mdi-arrow-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required, numeric } from "vuelidate/lib/validators";
import commonService from "@/services/CommonService/commonService.js";
import Loading from "vue-loading-overlay";
export default {
  name: "AccountSection",
  components: {
    Loading,
  },
  data() {
    return {
      name: "",
      isSubmitted: false,
      fullPage: true,
      height: 100,
      width: 100,
      payment_method: 11,
      bank_names: [],
    };
  },
  props: {
    beneficiaryReqBody: {
      type: Object,
      required: true,
    },
    loader: {
      type: Boolean,
    },
    BusrecieverData: {
      type: Object,
      required: true,
    },
    isTrans: {
      type: String,
      default: "",
    },
    country_code: {
      type: String,
      default: "",
    },
  },
  validations() {
    return {
      beneficiaryReqBody: {
        bank_name: {
          required,
        },

        bank_account_no: {
          required,
          numeric,
        },
        // branch_code: {
        //   alphaNum,
        // },
        // swift_no: {
        //   required,
        // },
      },
    };
  },
  computed: {
    bankNameErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.bank_name.$dirty) return errors;
      if (!this.$v.beneficiaryReqBody.bank_name.required) {
        errors.push(this.$t("select_bank_name"));
      }
      return errors;
    },
    accountNoErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.bank_account_no.$dirty) return errors;
      !this.$v.beneficiaryReqBody.bank_account_no.required &&
        errors.push(this.$t("account_number"));
      if (!this.$v.beneficiaryReqBody.bank_account_no.numeric) {
        errors.push(this.$t("invalid_account_num"));
      }
      return errors;
    },
    // ifscCodeErrors() {
    //   const errors = [];
    //   if (!this.$v.beneficiaryReqBody.branch_code.$dirty) return errors;

    //   return errors;
    // },
    // swiftCodeErrors() {
    //   const errors = [];
    //   if (!this.$v.beneficiaryReqBody.swift_no.$dirty) return errors;
    //   !this.$v.beneficiaryReqBody.swift_no.required &&
    //     errors.push(this.$t("swift_code_required"));
    //   return errors;
    // },
  },
  created() {
    if (this.BusrecieverData.receiver_id) {
      this.beneficiaryReqBody.branch_code = this.BusrecieverData.branch_code;
      this.beneficiaryReqBody.bank_name = this.BusrecieverData.location_name;
      this.beneficiaryReqBody.swift_no = this.BusrecieverData.swift_no;
      this.beneficiaryReqBody.bank_account_no =
        this.BusrecieverData.bank_account_no;
    }
  },
  watch: {
    country_code: {
      handler(newVal) {
        this.getpayLocation(newVal);
      },
    },
    "beneficiaryReqBody.bank_name"(newVal) {
      if (newVal) {
        this.beneficiaryReqBody.location_id = newVal.location_id;
        this.beneficiaryReqBody.location_name = newVal.location_name;
      }
    },
  },
  methods: {
    onClickCancel() {
      this.$router.push("/transaction/3");
    },
    onClickNext() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$emit("onClickNext", this.beneficiaryReqBody);
    },
    onClickBack() {
      this.$emit("onClickBack");
    },
    async getpayLocation(selected_country) {
      try {
        const responseData = await commonService.getPayoutLocByctry({
          country: selected_country,
          payment_mode: "B",
          txn_type: "IND",
        });
        console.log("getpayLocation:", responseData);
        if (responseData.status == 200) {
          this.bank_names = await responseData.data.data.map((i) => {
            return {
              txt: i.locationName,
              val: {
                location_id: i.locationId,
                location_name: i.locationName,
              },
            };
          });
          if (this.BusrecieverData && this.BusrecieverData.location_id) {
            this.beneficiaryReqBody.bank_name = {
              location_id: this.BusrecieverData.location_id,
              location_name: this.BusrecieverData.location_name,
            };
            this.beneficiaryReqBody.location_id =
              this.BusrecieverData.location_id;
            this.beneficiaryReqBody.location_name =
              this.BusrecieverData.location_name;
          }
        } else {
          return;
        }
      } catch (err) {
        console.error(err);

        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.invalid-feedback-password {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
.invalid-feedback-confirm {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
.invalid-feedback-swift {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
@media (min-width: 768px) {
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
    margin: auto;
  }
}
</style>
